module.exports = __webpack_public_path__ + "img/rich-checked-in.565bb19f.png";